import React from 'react';
import { useSelector } from "react-redux";
import User from "../../models/User";
import MenuItem from '../MenuItem/MenuItem';
import { ReactComponent as DashboardIcon } from '../../assets/icons-menu/dashboard.svg';
import { ReactComponent as DisplayIcon } from '../../assets/icons-menu/display.svg';
import { ReactComponent as DisplayGroupIcon } from '../../assets/icons-menu/display-group.svg';
import { ReactComponent as InksIcon } from '../../assets/icons-menu/inks.svg';
import { ReactComponent as ScheduleIcon } from '../../assets/icons-menu/schedule.svg';
import { ReactComponent as ListsIcon } from '../../assets/icons-menu/lists.svg';
import { ReactComponent as MediaIcon } from '../../assets/icons-menu/media.svg';
import { ReactComponent as WidgetsIcon } from '../../assets/icons-menu/widgets.svg';
import { ReactComponent as TagIcon } from '../../assets/icons-menu/tag.svg';
import { ReactComponent as LicencesIcon } from '../../assets/icons-menu/licences.svg';
import { ReactComponent as UsersIcon } from '../../assets/icons-menu/users.svg';
import { ReactComponent as AdministrationIcon } from '../../assets/icons-menu/administration.svg';

interface AsideMenuProps {
    isOpen?: boolean;
    onClose?: () => void;
};

const AsideMenu: React.FC<AsideMenuProps> = (props: AsideMenuProps) => {

    const authReducer = useSelector( (store: any) => store.authReducer );
    const user: User = authReducer.user ?? {};

    const _getProvMenu = () => {

        const actions: string[] = user.actions ?? [];

        let provMenu = [
            {
                link: '/dashboard',
                icon: DashboardIcon,
                text: 'Dashboard'
            },
            {
                link: '/screens',
                icon: DisplayIcon,
                text: 'Screens'
            }

        ];

        if(actions.includes('screengroup.index')) {
            provMenu.push(
                {
                    link: '/screengroups',
                    icon: DisplayGroupIcon,
                    text: 'Screen Groups'
                }
            );
        }

        provMenu.push(
            {
                link: '/eink',
                icon: InksIcon,
                text: 'Ink'
            },
            {
                link: '/schedule',
                icon: ScheduleIcon,
                text: 'Schedule'
            },
            {
                link: '/playlists',
                icon: ListsIcon,
                text: 'Playlists'
            },
            {
                link: '/library',
                icon: MediaIcon,
                text: 'Library'
            },
            {
                link: '/widgets',
                icon: WidgetsIcon,
                text: 'Widgets'
            }
        );

        if(actions.includes('tag.index')) {
            provMenu.push(
                {
                    link: '/tags',
                    icon: TagIcon,
                    text: 'Tags'
                }
            );
        }

        if(actions.includes('license.store') || actions.includes('licensegroup.store')) {
            provMenu.push(
                {
                    link: '/licenses',
                    icon: LicencesIcon,
                    text: 'Licenses'
                }
            );
        }

        if(actions.includes('user.store')) {
            provMenu.push(
                {
                    link: '/hierarchy',
                    icon: UsersIcon,
                    text: 'Hierarchy'
                }
            );
        }

        provMenu.push(
            {
                link: '/admin',
                icon: AdministrationIcon,
                text: 'Administration'
            }
        );

        return provMenu;

    }

    return(
        <>
            <div
                className={`main-menu__backdrop ${props.isOpen ? 'is-open' : ''}`}
                onClick={props.onClose}
            />
            <aside className={`main-menu ${props.isOpen ? 'is-open' : ''}`}>
                <ul>
                    {
                        _getProvMenu().map( (item, index) => {
                            return (
                                <MenuItem
                                    key={index}
                                    link={item.link}
                                    text={item.text}
                                    icon={item.icon}
                                    onClick={props.onClose}
                                />
                            )
                        })
                    }
                </ul>
                <div className="main-menu__appVersion">
                    { process.env.REACT_APP_VERSION }
                </div>
            </aside>
        </>
    );

};

export default React.memo(AsideMenu);
